<template>
    <div id="ap">
        <a-layout>
            <div class="content-header">
                <a-affix :offset-top="0" style="width: 100%;">
                    <a-row type="flex" justify="space-between">
                        <a-col span="8">
                            <common-page-btn @save="$refs.couponActiveFormRef.show()"></common-page-btn>
                        </a-col>
                        <a-col span="16">
                            <a-row type="flex" align="middle" justify="end" :gutter="10">
                                <a-col span="6">
                                    <a-input v-model="param.keyword" allowClear search @pressEnter="getList"
                                        @on-clear="getList" placeholder="关键词查询"></a-input>
                                </a-col>
                                <a-col span="8">
                                    <choose-organ v-model="param.organId" @change="organChange"
                                        allowClear></choose-organ>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </a-affix>
            </div>
        </a-layout>

        <a-layout>
            <a-layout-content>
                <a-table :defaultExpandAllRows="true" :scroll="{ x: '100%' }" :pagination="false" :indentSize="25"
                    :style="{ background: '#FFF' }" size="small" row-key="activeId" border :columns="keys" ref="list"
                    :loading="loading" :data-source="data.records">
                    <template slot-scope="row" slot="name">
                        <a href="#">{{ row.title }}</a>
                    </template>
                    <template slot-scope="row" slot="coupon">
                        <a-space>
                            <span v-if="row.discount > 0">{{ row.discount / 10 }}折</span>
                            <span v-if="row.money > 0">{{ row.money }} 元 </span>
                            <span>{{ row.couponType }}</span>
                            <span v-if="row.fullMoney > 0">消费满{{ row.fullMoney }}元可用</span>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="storeNum">
                        {{ getStoreNum(row.scopeIds) }}
                    </template>
                    <template slot-scope="row" slot="time">
                        <a-space>
                            <a-tag color="green">{{ row.startTime }}</a-tag>
                            <span>~</span>
                            <a-tag color="red">{{ row.overTime }}</a-tag>
                        </a-space>
                    </template>
                    <template slot-scope="row" slot="state">
                        <a-tag v-if="row.status == '已发布'" color="green">{{ row.status }}</a-tag>
                        <a-tag v-else-if="row.status == '未发布'" color="red">{{ row.status }}</a-tag>
                        <a-tag v-else>{{ row.status }}</a-tag>
                    </template>
                    <template slot-scope="row" slot="action">
                        <a-button-group shape="circle" size="small">
                            <a-tooltip title="编辑"><a-button type="link" v-has="'coupon:active:save'" icon="edit"
                                    @click="$refs.couponActiveFormRef.show(row)"></a-button></a-tooltip>
                            <a-tooltip title="删除"><a-button type="link" v-has="'coupon:active:delete'" icon="delete"
                                    @click="del(row.activeId)"></a-button></a-tooltip>
                        </a-button-group>
                    </template>
                </a-table>
            </a-layout-content>
        </a-layout>
        <a-row>
            <a-col span="12" offset="6" style="text-align: center; padding: 20px 0;">
                <a-pagination :defaultPageSize="param.limit" :total="data.total" @change="getNext"
                    @showSizeChange="setLimit" :current="data.current" />
            </a-col>
        </a-row>
        <coupon-active-form ref="couponActiveFormRef" @success="doRefresh"></coupon-active-form>
    </div>
</template>

<script>
import apiUtil from "@/common/apiUtil";
import ExporttoExcel from "@/common/ExportExcel.js";
import utils from '@/common/utils';
import couponActiveForm from "./components/coupon-active-form.vue";
import dayjs from "dayjs";
export default {
    components: { couponActiveForm },
    data() {
        return {
            confirmLoading: false,
            visible: false,
            loading: false,
            status: '',
            data: { records: [] },
            param: {
                page: 1,
                limit: 20,
                keyword: '',
                organId: apiUtil.getDefaultOrganId(),
            },
            organList: apiUtil.getOrganList(),
            keys: [
                { title: '活动名称', scopedSlots: { customRender: 'name' }, ellipsis: true },
                { title: '活动奖品', scopedSlots: { customRender: 'coupon' }, width: 260, align: 'left', ellipsis: true },
                { title: '商家出资', customRender: (row) => { return row.storeFee + '%' }, width: 300, align: 'center', ellipsis: true },
                { title: '可用商家', scopedSlots: { customRender: 'storeNum' }, width: 140, align: 'center', ellipsis: true },
                { title: '活动时间', scopedSlots: { customRender: 'time' }, width: 300, align: 'center', ellipsis: true },
                { title: '状态', scopedSlots: { customRender: 'state' }, width: 160, align: 'center', ellipsis: true },
                { title: '操作', scopedSlots: { customRender: 'action' }, align: 'center', width: 200 }
            ],
        };
    },
    created() {
        this.doRefresh();
    },
    methods: {
        getStoreNum(ids) {
            if (ids == '' || ids == null || ids == undefined) {
                return '所有商家参与';
            }
            let id = ids.split(',');
            return '共 ' + id.length + ' 个商家参与';
        },
        organChange() {
            this.param.cateId = '';
            this.doRefresh();
        },
        //删除
        del(id) {
            this.utils.confirm('删除后无法恢复，是否确认?').then(() => {
                utils.showSpin();
                this.http.delete('/platform/coupon/active/delete/' + id).then(ret => {
                    if (ret.code == 200) {
                        this.utils.success('操作成功！').then(() => {
                            this.getList();
                        });
                    }
                });
            });
        },
        // 获取数据
        getList() {
            this.loading = true;
            this.http
                .get('/platform/coupon/active/list', this.param)
                .then(ret => {
                    // console.log(ret);
                    this.data = ret.data;
                }).finally(() => {
                    this.loading = false;
                });
        },
        // 导出excel
        ExportEx() {
            if (this.data.records.length > 0) {
                const filterData = this.data.records.map((item) => {
                    return { '商户名称': item.name, "负责人": item.person, "手机号": item.phone, "地址": item.address, "提交日期": item.createDate, "所属单位": item.organName, "备注": item.remark, "状态": item.status };
                });
                const organ = apiUtil.getOrganList().filter(item => item.organId == this.param.organId);
                let organName = '';
                if (organ.length == 0) {
                    organName = "所有单位";
                } else {
                    organName = organ[0].name;
                }
                ExporttoExcel(filterData, `${organName}商户记录表.xlsx`);
            } else {
                this.$message.info('没有数据哦！！!');
                return;
            }
        },
        doRefresh() {
            this.param.page = 1;
            this.getList();
        },
        //设置每页的显示条数
        setLimit(current, limit) {
            this.param.page = 1;
            this.param.limit = limit;
        },
        //页码切换
        getNext(page) {
            this.param.page = page;
            this.getList();
        }
    }
};
</script>

<style scoped></style>
